import { render, staticRenderFns } from "./viewallNews.vue?vue&type=template&id=9e0b838c&scoped=true"
import script from "./viewallNews.vue?vue&type=script&lang=js"
export * from "./viewallNews.vue?vue&type=script&lang=js"
import style0 from "./viewallNews.vue?vue&type=style&index=0&id=9e0b838c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0b838c",
  null
  
)

export default component.exports